import * as i0 from '@angular/core';
import { Injectable, Directive, Host, Input, HostBinding, TemplateRef, Component, ViewEncapsulation, ViewChild, ContentChild, NgModule } from '@angular/core';
import { TourService, TourHotkeyListenerComponent, TourBackdropService, TourModule } from 'ngx-ui-tour-core';
import * as i3 from '@angular/common';
import { CommonModule } from '@angular/common';
import { NgbPopover, NgbPopoverModule } from '@ng-bootstrap/ng-bootstrap';
import { first } from 'rxjs/operators';

class NgbTourService extends TourService {
}
NgbTourService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.7", ngImport: i0, type: NgbTourService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
NgbTourService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.2.7", ngImport: i0, type: NgbTourService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.7", ngImport: i0, type: NgbTourService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }] });

class TourStepTemplateService {
}
TourStepTemplateService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.7", ngImport: i0, type: TourStepTemplateService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
TourStepTemplateService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.2.7", ngImport: i0, type: TourStepTemplateService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.7", ngImport: i0, type: TourStepTemplateService, decorators: [{
            type: Injectable
        }] });

class TourAnchorNgBootstrapPopoverDirective extends NgbPopover {
}
TourAnchorNgBootstrapPopoverDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.7", ngImport: i0, type: TourAnchorNgBootstrapPopoverDirective, deps: null, target: i0.ɵɵFactoryTarget.Directive });
TourAnchorNgBootstrapPopoverDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.2.7", type: TourAnchorNgBootstrapPopoverDirective, selector: "[tourAnchor]", usesInheritance: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.7", ngImport: i0, type: TourAnchorNgBootstrapPopoverDirective, decorators: [{
            type: Directive,
            args: [{ selector: '[tourAnchor]' }]
        }] });
class TourAnchorNgBootstrapDirective {
    constructor(tourService, tourStepTemplate, element, popoverDirective) {
        this.tourService = tourService;
        this.tourStepTemplate = tourStepTemplate;
        this.element = element;
        this.popoverDirective = popoverDirective;
        this.popoverDirective.autoClose = false;
        this.popoverDirective.triggers = '';
        this.popoverDirective.toggle = () => { };
    }
    ngOnInit() {
        this.tourService.register(this.tourAnchor, this);
    }
    ngOnDestroy() {
        this.tourService.unregister(this.tourAnchor);
    }
    async showTourStep(step) {
        if (this.popoverDirective.isOpen()) {
            // TODO: use firstValueFrom() instead of deprecated "toPromise()" after dropping rxjs v6 support
            await this.popoverDirective.hidden.pipe(first()).toPromise();
        }
        this.isActive = true;
        this.popoverDirective.ngbPopover = this.tourStepTemplate.template;
        this.popoverDirective.popoverTitle = step.title;
        this.popoverDirective.container = 'body';
        this.popoverDirective.placement = (step.placement || 'auto')
            .replace('before', 'left').replace('after', 'right')
            .replace('below', 'bottom').replace('above', 'top');
        this.popoverDirective.open({ step });
    }
    hideTourStep() {
        this.isActive = false;
        this.popoverDirective.close();
    }
}
TourAnchorNgBootstrapDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.7", ngImport: i0, type: TourAnchorNgBootstrapDirective, deps: [{ token: NgbTourService }, { token: TourStepTemplateService }, { token: i0.ElementRef }, { token: TourAnchorNgBootstrapPopoverDirective, host: true }], target: i0.ɵɵFactoryTarget.Directive });
TourAnchorNgBootstrapDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.2.7", type: TourAnchorNgBootstrapDirective, selector: "[tourAnchor]", inputs: { tourAnchor: "tourAnchor" }, host: { properties: { "class.touranchor--is-active": "this.isActive" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.7", ngImport: i0, type: TourAnchorNgBootstrapDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[tourAnchor]',
                }]
        }], ctorParameters: function () { return [{ type: NgbTourService }, { type: TourStepTemplateService }, { type: i0.ElementRef }, { type: TourAnchorNgBootstrapPopoverDirective, decorators: [{
                    type: Host
                }] }]; }, propDecorators: { tourAnchor: [{
                type: Input
            }], isActive: [{
                type: HostBinding,
                args: ['class.touranchor--is-active']
            }] } });

class TourStepTemplateComponent extends TourHotkeyListenerComponent {
    constructor(tourStepTemplateService, tourService) {
        super(tourService);
        this.tourStepTemplateService = tourStepTemplateService;
        this.tourService = tourService;
    }
    ngAfterContentInit() {
        this.tourStepTemplateService.template =
            this.stepTemplate ||
                this.stepTemplateContent ||
                this.defaultTourStepTemplate;
    }
}
TourStepTemplateComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.7", ngImport: i0, type: TourStepTemplateComponent, deps: [{ token: TourStepTemplateService }, { token: NgbTourService }], target: i0.ɵɵFactoryTarget.Component });
TourStepTemplateComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.7", type: TourStepTemplateComponent, selector: "tour-step-template", inputs: { stepTemplate: "stepTemplate" }, queries: [{ propertyName: "stepTemplateContent", first: true, predicate: TemplateRef, descendants: true }], viewQueries: [{ propertyName: "defaultTourStepTemplate", first: true, predicate: ["tourStep"], descendants: true, read: TemplateRef, static: true }], usesInheritance: true, ngImport: i0, template: `
    <ng-template #tourStep let-step="step">
      <p class="tour-step-content" [innerHTML]="step?.content"></p>
      <div class="tour-step-navigation">
        <button
          *ngIf="tourService.hasPrev(step)"
          class="btn btn-sm btn-default"
          (click)="tourService.prev()"
        >
          « {{ step?.prevBtnTitle }}
        </button>
        <button
          *ngIf="tourService.hasNext(step) && !step.nextOnAnchorClick"
          class="btn btn-sm btn-default"
          (click)="tourService.next()"
        >
          {{ step?.nextBtnTitle }} »
        </button>
        <button class="btn btn-sm btn-default" (click)="tourService.end()">
          {{ step?.endBtnTitle }}
        </button>
      </div>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.7", ngImport: i0, type: TourStepTemplateComponent, decorators: [{
            type: Component,
            args: [{
                    encapsulation: ViewEncapsulation.None,
                    selector: 'tour-step-template',
                    template: `
    <ng-template #tourStep let-step="step">
      <p class="tour-step-content" [innerHTML]="step?.content"></p>
      <div class="tour-step-navigation">
        <button
          *ngIf="tourService.hasPrev(step)"
          class="btn btn-sm btn-default"
          (click)="tourService.prev()"
        >
          « {{ step?.prevBtnTitle }}
        </button>
        <button
          *ngIf="tourService.hasNext(step) && !step.nextOnAnchorClick"
          class="btn btn-sm btn-default"
          (click)="tourService.next()"
        >
          {{ step?.nextBtnTitle }} »
        </button>
        <button class="btn btn-sm btn-default" (click)="tourService.end()">
          {{ step?.endBtnTitle }}
        </button>
      </div>
    </ng-template>
  `
                }]
        }], ctorParameters: function () { return [{ type: TourStepTemplateService }, { type: NgbTourService }]; }, propDecorators: { defaultTourStepTemplate: [{
                type: ViewChild,
                args: ['tourStep', { read: TemplateRef, static: true }]
            }], stepTemplate: [{
                type: Input
            }], stepTemplateContent: [{
                type: ContentChild,
                args: [TemplateRef]
            }] } });

class TourNgBootstrapModule {
    static forRoot() {
        return {
            ngModule: TourNgBootstrapModule,
            providers: [
                TourStepTemplateService,
                TourService,
                NgbTourService,
                TourBackdropService
            ],
        };
    }
}
TourNgBootstrapModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.7", ngImport: i0, type: TourNgBootstrapModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
TourNgBootstrapModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.2.7", ngImport: i0, type: TourNgBootstrapModule, declarations: [TourAnchorNgBootstrapDirective, TourAnchorNgBootstrapPopoverDirective, TourStepTemplateComponent], imports: [CommonModule, NgbPopoverModule, TourModule], exports: [TourAnchorNgBootstrapDirective, TourAnchorNgBootstrapPopoverDirective, TourStepTemplateComponent] });
TourNgBootstrapModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.2.7", ngImport: i0, type: TourNgBootstrapModule, imports: [CommonModule, NgbPopoverModule, TourModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.7", ngImport: i0, type: TourNgBootstrapModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [TourAnchorNgBootstrapDirective, TourAnchorNgBootstrapPopoverDirective, TourStepTemplateComponent],
                    exports: [TourAnchorNgBootstrapDirective, TourAnchorNgBootstrapPopoverDirective, TourStepTemplateComponent],
                    imports: [CommonModule, NgbPopoverModule, TourModule],
                }]
        }] });

/*
 * Public API Surface of ngx-ui-tour-ng-bootstrap
 */

/**
 * Generated bundle index. Do not edit.
 */

export { NgbTourService, TourAnchorNgBootstrapDirective, TourAnchorNgBootstrapPopoverDirective, TourNgBootstrapModule, NgbTourService as TourService, TourStepTemplateComponent };
